import { CompatAnalyticsAdapter } from './adapters';
import type { AnalyticsTrackPayload as _AnalyticsTrackPayload } from './adapters/analytics-adapter';
import type { Event } from './events';

export type AnalyticsTrackPayload = _AnalyticsTrackPayload<Event>;

export const analyticsAdapter = new CompatAnalyticsAdapter<Event>();
